import { NgModule }              from "@angular/core";
import { FormsModule }           from "@angular/forms";
import { TurMenuComponent }      from "./menu/tur-menu.component";
import { ThemeTurComponent }     from "./theme-tur.component";
import { ThemeTurRoutingModule } from "./theme-tur-routing.module";
import { DirectivesModule }      from "../../directives/directives.module";
import { PipesModule }             from "../../pipes/pipes.module";
import { ComponentsModule }          from "../../components/components.module";
import { CommonModule }              from "@angular/common";
import { TurOptionsComponent }       from "./options/tur-options.component";
import { TurPayingComponent }        from "./paying/tur-paying.component";
import { TurComponentsModule }       from "../../components/tur/tur.components.module";
import { TurCupComponent }           from "./cup/tur-cup.component";
import { TurServingComponent }       from "./serving/tur-serving.component";
import { TurWarningComponent }       from './warning/tur-warning.component';
import { TurServedComponent }        from './served/tur-served.component';
import { TurMaintenanceComponent }   from './maintenance/tur-maintenance.component';
import { MatTabsModule }             from "@angular/material/tabs";
import { MAT_RIPPLE_GLOBAL_OPTIONS } from "@angular/material/core";
import { MatFormFieldModule }        from "@angular/material/form-field";
import { MatSelectModule }           from "@angular/material/select";
import { TurUpdateComponent }        from "./update/tur-update.component";

const PAGES = [
	ThemeTurComponent,
	TurMenuComponent,
	TurOptionsComponent,
	TurPayingComponent,
	TurCupComponent,
	TurServingComponent,
	TurWarningComponent,
	TurServedComponent,
	TurMaintenanceComponent,
	TurUpdateComponent
];

@NgModule({
	imports: [
		FormsModule,
		ThemeTurRoutingModule,
		CommonModule,
		FormsModule,
		ComponentsModule,
		PipesModule,
		DirectivesModule,
		TurComponentsModule,
		MatTabsModule,
		MatFormFieldModule,
		MatSelectModule
	],
	exports: [
		...PAGES
	],
	declarations: [
		...PAGES
	],
	providers: [
		{provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: {disabled:true}}
	]
})
export class ThemeTurModule {
}
